"use client";

import { Mail } from "lucide-react";
import { getSocialMediaIcon } from "@/app/[locale]/projects/util/social-media-icon";

export function SocialMediaLinks({ projectDetail, charity }: {
  projectDetail: {
    socialMedia?: { platform?: string; url?: string }[];
    email?: string | null;
    website?: string | null;
  };
  charity?: { socialMedia?: { platform?: string; url?: string }[]; website?: string } | null;
}) {
  const socials = projectDetail.socialMedia?.length
    ? projectDetail.socialMedia
    : charity?.socialMedia ?? [];
  const hasWebsiteEntry = socials.some(
    (s) => s.platform?.toLowerCase() === "website"
  );
  const websiteSource = projectDetail.website || charity?.website;
  const websiteFallback =
    !hasWebsiteEntry && websiteSource
      ? [{ platform: "WEBSITE", url: websiteSource.match(/^https?:\/\//) ? websiteSource : `https://${websiteSource}` }]
      : [];
  const allLinks = [...socials, ...websiteFallback];
  const showEmail = !!projectDetail.email;
  if (allLinks.length === 0 && !showEmail) return null;

  return (
    <div className="flex gap-3 justify-center md:justify-start">
      {showEmail && (
        <a
          href={`mailto:${projectDetail.email}`}
          className="p-2 hover:bg-muted rounded-md transition-colors"
          title="E-Mail"
        >
          <Mail size={20} />
        </a>
      )}
      {allLinks.map((social, index) => (
        <a
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 hover:bg-muted rounded-md transition-colors"
          title={social.platform}
        >
          {getSocialMediaIcon(social.platform || "")}
        </a>
      ))}
    </div>
  );
}
